import React from "react"
import { connect } from "react-redux"

import {
    patchColumnData,
    editResourceTableRow,
} from "sheets/sheet-action-creators"
import { getEnumValueForPatch } from "sheets/helper-functions"
import { Cell } from "fixed-data-table-2"
import { AbstractEnumSelect } from "selects/containers/EnumSelect"
import omit from "lodash/omit"
import PropTypes from "prop-types"

// render a select within a cell in sheets
export const EnumSelectCell = ({
    choices,
    clearable,
    columnId,
    columnIndex,
    enumFieldName,
    isResourceTable,
    item,
    rowId,
    sendRowIds,
    id, // should be named sheetKey - the table name for resource tables
    ...props
}) => {
    const handleChange = (enumObj) => {
        if (isResourceTable) {
            props.editResourceTableRow(id, rowId, enumObj ? { [enumFieldName]: enumObj.value } : {}, props.cellStateMappingFunc)
        } else {
            props.patchColumnData({
                id,
                columnId,
                rowId,
                newValue: getEnumValueForPatch(enumObj),
                includeRowIds: sendRowIds
            })
        }
    }
    return (
        <div
            // neccessary because the Select onClick() event propagates down to the SheetCell onClick() every time we click on a select,
            // which re-calls clickCell() after the unclickCell() action creator is fired in patchColumnData of sheet-action-creators
            // Since it is not possible to pass an onClick prop down to a react-select component, this is necessary
            // https://github.com/JedWatson/react-select/issues/532
            onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
            }}
        >
            <Cell {...omit(props, ["patchColumnData", "editResourceTableRow"])}>
                <AbstractEnumSelect
                    autofocus
                    clearable={clearable}
                    value={item.value}
                    options={choices}
                    onChange={handleChange}
                    allowExpandUp
                />
            </Cell>
        </div>
    )
}

EnumSelectCell.propTypes = {
    item: PropTypes.object,
    patchColumnData: PropTypes.func.isRequired,
    editResourceTableRow: PropTypes.func.isRequired,
}

EnumSelectCell.defaultProps = {
    item: {},
    clearable: false,
    sendRowIds: false,
}

export default connect(null, { patchColumnData, editResourceTableRow })(EnumSelectCell)
